export function contactSchema(contactDocument) {
  if (!contactDocument || !contactDocument.data) {
    return;
  }
  const jsonLinkedData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: location.origin.toString(),
    contactPoint: [{
      '@type': 'ContactPoint',
      telephone: contactDocument.data.telephoneLV,
      contactType: 'customer service',
      contactOption: [
        'TollFree',
      ],
      areaServed: 'LVA',
      availableLanguage: [
        'English',
        'Russian',
        'Latvian',
      ],
    }, {
      '@type': 'ContactPoint',
      telephone: contactDocument.data.telephoneEE,
      contactType: 'customer service',
      contactOption: [
        'TollFree',
      ],
      areaServed: 'EST',
      availableLanguage: [
        'English',
        'Russian',
        'Estonian',
      ],
    }, {
      '@type': 'ContactPoint',
      telephone: contactDocument.data.telephoneLT,
      contactType: 'customer service',
      contactOption: [
        'TollFree',
      ],
      areaServed: 'LTU',
      availableLanguage: [
        'English',
        'Russian',
        'Lithuanian',
      ],
    }],
  };
  document.getElementById('scriptJSON').innerText = JSON.stringify(jsonLinkedData);
}
